import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss'],
})
export class RedirectComponent {
  path: string;
  loading = true;

  constructor(private activateRoute: ActivatedRoute, private router: Router) {
    this.path = this.activateRoute.snapshot.url[0].path;
    if (this.path === 'store') {
      const storeId = this.activateRoute.snapshot.params.storeId;
      this.router.navigate([`pages/partners/view/null/store-groups/null/store/${storeId}/info`]).then();
    }

    if (this.path === 'company') {
      const companyId = this.activateRoute.snapshot.params.companyId;
      this.router.navigate([`/pages/partners/view/${companyId}/info`]).then();
    }
  }
}
